<template>
  <div id="app">
    <header
      class="header"
      :style="showWanasaLogo ? 'background:#fff' : ''"
      v-if="
        routeName !== '/qrCode' &&
          routeName !== '/details' &&
          routeName !== '/showtime'
      "
    >
      <div class="header-left">
        <button
          v-if="
            routeName !== '/' &&
              routeName !== '/login' &&
              routeName !== '/manual' &&
              routeName !== '/home'
          "
          class="btn-sidebar"
          @click="sidebar = !sidebar"
        >
          <img src="@/assets/img/hamburger.png" height="30" width="30" />
        </button>

        <button
          class="btn-sidebar"
          v-if="routeName === '/manual'"
          @click="$router.go(-1)"
        >
          <img src="@/assets/img/arrow_back.svg" />
        </button>
      </div>
      <div class="header-center">
        <img
          v-if="isMifClient"
          src="@/assets/img/brij.png"
          height="auto"
          width="100"
          alt="Brij-Logo"
        />
        <img
          v-else-if="!showWanasaLogo"
          src="@/assets/img/Nuvio_Primary Logo.png"
          height="auto"
          width="80"
          alt="Brij-Logo"
        />
        <img
          v-if="showWanasaLogo"
          src="@/assets/img/wanasaImage.png"
          height="auto"
          width="130"
          class="login-brand"
        />
      </div>
      <div class="header-right">
        <button
          class="logout-btn"
          v-if="routeName === '/home'"
          @click="onLogout()"
        >
          Logout
        </button>
      </div>
    </header>

    <aside
      v-if="routeName !== '/' && routeName !== '/login'"
      :class="['app-aside', sidebar ? 'active' : null]"
    >
      <!-- <router-link to="qrCode">QR Code</router-link>
      <hr class="my-0" /> -->
      <router-link @click.native="onLogout" to>Logout</router-link>

      <div class="d-flex justify-content-center position-absolute fixed-bottom">
        <p>v{{ this.version }}</p>
      </div>
    </aside>
    <div class="backdrop" v-if="sidebar" @click="sidebar = !sidebar"></div>
    <router-view></router-view>
  </div>
</template>

<script>
import { version } from "../package.json";
import BookingService from "@/services/BookingService";
export default {
  name: "app",
  data() {
    return {
      version,
      sidebar: false,
      showWanasaLogo: false,
      entry_id_required: "N"
    };
  },
  beforeMount() {
    this.GetGlobalOptions();
    this.showWanasaLogo = window.location.origin.includes("wanasa");
  },
  computed: {
    routeName: function ß() {
      return this.$route.path;
    },
    isQfxClient() {
      if (window.localStorage.getItem("CLIENT_NAME")) {
        return (
          window.localStorage.getItem("CLIENT_NAME").toLowerCase() === "qfx"
        );
      } else if (window.location.origin.includes("qfx")) {
        return true;
      } else {
        return false;
      }
    },
    isMifClient() {
      if (typeof window === "undefined") return false;

      const clientName = window.localStorage.getItem("CLIENT_NAME");

      if (clientName) {
        return clientName.toLowerCase() === "mif";
      }

      return window.location.origin.toLowerCase().includes("mif");
    }
  },
  methods: {
    GetGlobalOptions: function() {
      BookingService.GetGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let EntrySettings = data.Records.filter(
              x => x.go_key == "ENTRY_ID_REQUIRED_QRAPP"
            );
            // console.log(EntrySettings, "EntrySettings");
            if (EntrySettings && EntrySettings.length > 0) {
              this.entry_id_required = EntrySettings[0].go_value;

              window.localStorage.setItem(
                "STBASEDENTRY",
                EntrySettings[0].go_value
              );
            } else {
              window.localStorage.setItem("STBASEDENTRY", "N");
            }
            let ClientSettings = data.Records.filter(
              x => x.go_key === "CLIENT_SETUP_NAME"
            );

            if (ClientSettings) {
              window.localStorage.setItem(
                "CLIENT_NAME",
                ClientSettings[0].go_value
              );
            }
          } else {
            window.localStorage.setItem("STBASEDENTRY", "N");
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          console.log("catch error on GetGlobalOptions :", error);
        });
    },
    onDecode(decodedString) {
      console.log("test");
      console.log("decodedString :", decodedString);
    },
    onLogout() {
      this.sidebar = false;
      window.localStorage.removeItem("JWT_TOKEN");
      window.localStorage.removeItem("USERCINEINFO");
      window.localStorage.clear();
      this.$cookie.delete("BRHSID");
      this.$router.push({
        name: "login"
      });
      return window.caches.keys();
    }
  }
};
</script>

<style>
.btn-sidebar {
  /* left: 10px;
  top: 20px; */
  border: none;
  /* position: absolute; */
  background-color: transparent;
}
.backdrop {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: block;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
}
.app-aside {
  top: 0;
  padding-top: 30px;
  left: -275px;
  width: 275px;
  z-index: 111;
  height: 100vh;
  position: fixed;
  transition: left 0.3s ease;
  background: #d3d3d3;
}

.app-aside.active {
  left: 0;
}

.app-aside a {
  display: block;
  font-size: 16px;
  font-weight: 500;
  color: #404040;
  padding: 10px 15px;
}

.app-aside a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue